import React from 'react';
import { Link } from 'react-router-dom';

const STEPS = [
  { id: 'before', when: 'Before', name: 'Consent receipt', q: 'Did I allow this agent to do this?', to: '/specs/consent-receipt', doc: 'consent' },
  { id: 'at', when: 'At the purchase', name: 'Purchase intent record', q: 'What did I actually ask for?', to: '/specs/claim-records', doc: 'claims' },
  { id: 'after', when: 'After', name: 'Claim records', q: 'What happened to my refund or complaint?', to: '/specs/claim-records', doc: 'claims' },
];

export function FamilyStrip({ current }) {
  return (
    <div className="mt-8 max-w-4xl" data-testid="family-strip">
      <div className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-3">One family of records the customer signs and keeps</div>
      <ol className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {STEPS.map((s) => {
          const here = s.doc === current;
          return (
            <li key={s.id}>
              <Link to={s.to} className={`block h-full rounded-xl border p-4 transition-colors ${here ? 'border-amber-400/50 bg-amber-500/[0.06]' : 'border-white/10 bg-white/[0.02] hover:border-white/25'}`} data-testid={`family-step-${s.id}`}>
                <div className={`text-[10px] uppercase tracking-widest mb-1 ${here ? 'text-amber-300' : 'text-gray-500'}`}>{s.when}{here ? ' · This page' : ''}</div>
                <div className="text-sm font-semibold text-white">{s.name}</div>
                <div className="text-xs text-gray-400 mt-1">{s.q}</div>
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
